import "./common/polyfill";
import "./state/mockApi";

import React from "react";
import { render } from "react-dom";
import { App, addThemeDefault } from "./common";
import getTheme from "./theme";
import site from "./site/default";

//import whyDidYouRender from "@welldone-software/why-did-you-render";

//if (process.env.NODE_ENV !== "production") {
//whyDidYouRender(React, {
//include: [/.*/],
////include: [/WorkflowContent/],
//include: [/Login/, /Content/, /App/, /AuthConsumer/, /Route/, /withAuth/],
//exclude: [/AppBar/]
//});
//}

getTheme.then(theme => {
  addThemeDefault(theme);
  addThemeDefault(site());

  render(
    <App
      pathPrefix={window.appInfo ? window.appInfo.pathPrefix : undefined}
    />,
    document.getElementById("_")
  );
});
